export default __webpack_public_path__ + "static/media/marker.c82601df.svg";